export const X_B2B_CLIENT_ID = 'X-B2b-Client-Id'
